import urls from '@/networkRequests/apiClient/endpoints'

import { configureRequest } from '../../../../../networkRequests/apiClient/apiClient.functions'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  GetAllTripsForAdminErrorResponse,
  GetAllTripsForAdminRequest,
  GetAllTripsForAdminSuccessResponse
} from './getAllTripsForAdmin.types'

export const getAllTripsForAdminApi = async (
  request: GetAllTripsForAdminRequest
): Promise<GetAllTripsForAdminSuccessResponse> => {
  const { page, size, searchQuery } = request

  const response = await configureRequest({
    url: urls.admin.getAllTripsForAdmin,
    method: 'GET',
    params: {
      page,
      size,
      ...(searchQuery ? { searchQuery } : {})
    },
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetAllTripsForAdminSuccessResponse
  } else {
    throw response as GetAllTripsForAdminErrorResponse
  }
}

export default getAllTripsForAdminApi
